export const MEDIA_CENTER_PAGE_KEY = "media_center_client";

export const MEDIA_SORT_OPTIONS = ["newest", "oldest", "rating", "likes", "title"];

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_MEDIA_CENTER_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#FF7F26",
  },
  sections: [
    {
      id: "header",
      type: "mediaHeader",
      visible: true,
      style: {},
      props: {
        headingAccent: "See talent in action!",
        heading: "Explore creative work.",
        subtext:
          "Browse videos, audio and presentations from creatives on KUVUMA. Get a real feel for their style, quality and range before you hire, and pick up fresh ideas for your next campaign, brand story or project.",
      },
    },
    {
      // Tab order and filter values are fixed (All, Video, Audio, Image, Presentation); only labels and visibility change.
      id: "tabs",
      type: "mediaTypeTabs",
      visible: true,
      style: {},
      props: {
        tabs: [
          { label: "All media", visible: true },
          { label: "Videos", visible: true },
          { label: "Audio", visible: true },
          { label: "Images", visible: true },
          { label: "Presentations / Slides", visible: true },
        ],
      },
    },
    {
      id: "filters",
      type: "mediaFilters",
      visible: true,
      style: {},
      props: {
        searchPlaceholder: "Search by media title or keyword",
        searchButton: "Search",
        categoryLabel: "Category",
        themeLabel: "Theme",
        topicLabel: "Topic",
        sortLabel: "Sort by",
        defaultSort: "newest",
      },
    },
    {
      id: "grid",
      type: "mediaGrid",
      visible: true,
      style: {},
      props: {},
    },
  ],
};

// Creator mode is not builder-managed; it keeps this heading.
export const CREATOR_MEDIA_HEADER = {
  headingAccent: "Connect, learn, grow!",
  heading: "Explore all media.",
  subtext:
    "Discover the latest trends and connect with industry leaders through our curated media content. Whether it's podcasts, interviews, or webinars, we provide you with the best resources to stay connected with the community.",
};
